import React from "react";
import { motion } from "framer-motion";

const row_one = [
  "#845EC2",
  "#D65DB1",
  "#FF6F91",
  "#FF9671",
  "#FFC75F",
  "#F9F871",
];

const row_two = [
  "#F9F871",
  "#FFC75F",
  "#FF9671",
  "#FF6F91",
  "#D65DB1",
  "#845EC2",
];

const BounceBox = (props) => {
  return (
    <motion.div
      className="box"
      style={{
        backgroundColor: props.colour,
      }}
      whileHover={{ scale: 1.2, transition: { duration: 0.05 } }}
      whileTap={{ scale: 0.75 }}
    ></motion.div>
  );
};

const Bounce = () => {
  return (
    <div>
      <h4>Bounce</h4>
      <p>
        <i>Only works with mouse hover.</i>
      </p>
      <div className="bounce">
        <div className="bounce-frame">
          {row_one.map((x, i) => (
            <BounceBox colour={x} key={i} />
          ))}
        </div>
        <div className="bounce-frame">
          {row_two.map((x, i) => (
            <BounceBox colour={x} key={i} />
          ))}
        </div>
        <div className="bounce-frame">
          {row_one.map((x, i) => (
            <BounceBox colour={x} key={i} />
          ))}
        </div>
        <div className="bounce-frame">
          {row_two.map((x, i) => (
            <BounceBox colour={x} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bounce;
